<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row>


				<v-flex xs12 sm6 offset-sm3>
					<v-card>
						<template v-if="isLoading">
							<div class="text-xs-center pa-5">
								<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
								<div class="caption mt-4">Liste yükleniyor</div>
							</div>
						</template>
						<template v-if="!isLoading">
							<v-toolbar color="indigo" dark>
								<v-text-field flat solo-inverted hide-details prepend-inner-icon="search"
									v-model="filterText" label="Ara" autocomplete="off" autocorrect="off"
									autocapitalize="off" spellcheck="false"></v-text-field>
							</v-toolbar>

							<v-list two-line>
								<template v-for="(item) in getItemsSuspended">
									<v-list-tile :key="item.user" avatar class="SuspendedLineSuspended">
										<v-list-tile-content>
											<v-list-tile-title> {{item.domain}} </v-list-tile-title>
											<v-list-tile-sub-title> {{item.suspendreason}} </v-list-tile-sub-title>
										</v-list-tile-content>
										<v-list-tile-action>
											<v-btn icon ripple @click="askForChange(item)">
												<v-icon color="error darken-1">play_circle_filled</v-icon>
											</v-btn>
										</v-list-tile-action>
									</v-list-tile>
								</template>
								<template v-for="(item) in getItemsNormal">
									<v-list-tile :key="item.user" avatar class="SuspendedLineNormal">
										<v-list-tile-content>
											<v-list-tile-title> {{item.domain}} </v-list-tile-title>
										</v-list-tile-content>
										<v-list-tile-action>
											<v-btn icon ripple @click="askForChange(item)">
												<v-icon color="success lighten-1">pause_circle_filled</v-icon>
											</v-btn>
										</v-list-tile-action>
									</v-list-tile>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>


				<v-dialog v-model="dialogPlayStop" max-width="400">
					<v-card v-if="dialogPlayStop">
						<v-card-title class="headline">Dikkat</v-card-title>

						<v-card-text v-if="item.suspended">
							Bu domain durdurulmuş. Devam ettirmek istediğinize emin misiniz ?
						</v-card-text>
						<v-card-text v-if="!item.suspended">
							Bu domaini durdurmak istediğinize emin misiniz ?
						</v-card-text>

						<v-card-actions>
							<v-btn color="warning darken-1" flat="flat" @click="dialogPlayStop = false">
								Vazgeç
							</v-btn>
							<v-spacer></v-spacer> 
							<v-btn color="green darken-1"  v-if="item.suspended"  @click="changeItem()" dark>
								Başlat
							</v-btn>
							<v-btn color="error darken-1"  v-if="!item.suspended"  @click="changeItem()">
								Durdur
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>



			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	export default {
		name: "DesignSiteIndex",
		components: {},
		data: () => ({
			isLoading: true,
			filterText: "",
			items_suspended: [],
			items_normal: [],
			item : {},
			dialogPlayStop : false,
		}),
		mounted() {
			this.loadItems();
		},
		methods: {
			loadItems() {
				this.isLoading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/server/accounts", {
					params: {}
				}).then(response => {
					this.items_suspended = [];
					this.items_normal = [];
					for (var i in response.body) {
						var item = response.body[i]
						if (item.suspended) {
							this.items_suspended.push(item)
						}
						if (!item.suspended) {
							this.items_normal.push(item)
						}
					}
					this.items = response.body;
					this.isLoading = false;
				})
			},
			askForChange(item){
				this.item = item;
				this.dialogPlayStop = true
			},
			changeItem(){
				this.isLoading = true;
				this.dialogPlayStop = false
				this.$http.post(process.env.VUE_APP_API_URL + "/server/suspended/change", this.item, {
					params: {}
				}).then(response => {
					this.loadItems();
				})
			}
		},
		computed: {
			getItemsSuspended() {
				var items = [];
				var filterText = this.filterText.toLowerCase();
				items = this.items_suspended.filter(function (item) {
					if (filterText != "") {
						if (item.domain.indexOf(filterText) < 0) {
							return false;
						}
					}
					return true;
				})
				items.sort(function (a, b) {
					var nameA = a.domain.toUpperCase();
					var nameB = b.domain.toUpperCase();
					if (nameA < nameB) {
						return -1;
					}
					if (nameA > nameB) {
						return 1;
					}
					return 0;
				});
				return items;
			},
			getItemsNormal() {
				var items = [];
				var filterText = this.filterText.toLowerCase();
				items = this.items_normal.filter(function (item) {
					if (filterText != "") {
						if (item.domain.indexOf(filterText) < 0) {
							return false;
						}
					}
					return true;
				})
				items.sort(function (a, b) {
					var nameA = a.domain.toUpperCase();
					var nameB = b.domain.toUpperCase();
					if (nameA < nameB) {
						return -1;
					}
					if (nameA > nameB) {
						return 1;
					}
					return 0;
				});
				return items;
			}
		}
	}
</script>



<style lang="less">
	.SuspendedLineSuspended .v-list__tile__title{
		color : rgb(153, 0, 0);
	}
	.SuspendedLineNormal .v-list__tile__title{
		color : rgb(0, 85, 7);
	}
</style>
